module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-3"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'people'
      }
    }
  }, [_vm._v("\n                People\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("\n            " + _vm._s(_vm.person.name) + "\n        ")])]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.person.name))]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.person.image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.person.phone) + "\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.person.function) + "\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "to": {
        name: 'people-edit',
        params: {
          id: _vm.person.id
        }
      }
    }
  }, [_vm._v("\n            edit\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removePerson()
      }
    }
  }, [_vm._v("remove")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a772b166"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/people/views/Details.vue
// module id = 111
// module chunks = 1